export enum UserRoles {
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    INFLUENCER = 'INFLUENCER',
    VIEWER = 'VIEWER',
}

export enum UserRolesNumeric {
    INFLUENCER = 1,
    VIEWER = 0,
}
